import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { ChatMessage } from '@/types/messages';

interface MessagesState {
  messages: ChatMessage[];
  unreadCount: number;
  lastScrollPosition: number;
  hasFetchedHistory: boolean;
}

interface MessagesActions {
  addMessage: (msg: ChatMessage) => void;
  setMessages: (messages: ChatMessage[]) => void;
  updateMessageStatus: (id: string, status: ChatMessage['status']) => void;
  addUniqueMessage: (msg: ChatMessage) => void;
  prependMessages: (msg: ChatMessage[]) => void;
  resetUnread: () => void;
  setScrollPosition: (pos: number) => void;
  incrementUnread: () => void;
  setHasFetchedHistory: (val: boolean) => void;
  resetMessages: () => void;
}

export const useMessagesStore = create(
  combine<MessagesState, MessagesActions>(
    {
      messages: [],
      unreadCount: 0,
      lastScrollPosition: 0,
      hasFetchedHistory: false
    },
    (set) => ({
      addMessage: (msg) =>
        set((state) => ({
          messages: [...state.messages, msg]
        })),
      setMessages: (messages) => set({ messages }),
      updateMessageStatus: (id, status) =>
        set((state) => ({
          messages: state.messages.map((m) => (m.id === id ? { ...m, status: status } : m))
        })),
      addUniqueMessage: (msg) =>
        set((state) =>
          state.messages.some((m) => m.id === msg.id)
            ? state
            : { messages: [...state.messages, msg] }
        ),
      prependMessages: (mapped) =>
        set((state) => ({
          messages: [...mapped, ...state.messages]
        })),
      resetUnread: () => set({ unreadCount: 0 }),
      incrementUnread: () =>
        set((state) => ({
          unreadCount: state.unreadCount + 1
        })),
      setScrollPosition: (pos) => set({ lastScrollPosition: pos }),
      setHasFetchedHistory: (val) => set({ hasFetchedHistory: val }),
      resetMessages: () =>
        set({
          messages: [],
          unreadCount: 0,
          lastScrollPosition: 0,
          hasFetchedHistory: false
        })
    })
  )
);
